<template>
	<div>
		<form-opinion
			v-if="!$route.meta.hideRating"
			@update="$emit('update-opinion')"
			:id="id"
		/>
		<opinion 
			v-for="(item, index) in opinions" 
			:key="index"
			:opinion="item"/>
	</div>
</template>
<script>
import opinion from '@/components/detail/opinion';
import formOpinion from '@/components/detail/formOpinion';

export default {
	name: 'wrapper-opinions',
	components: {
		opinion,
		formOpinion,
	},
	props: {
		opinions: {
			type: Array,
			default: () => [],
		},
		id: [String, Number],
	},
};
</script>




// WEBPACK FOOTER //
// wrapperOpinions.vue?2b2bbcac